/**
 * @desc 确认拆包裹并提交包裹
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(body: defs.omsFlow.DetachablePackageParamDto, options?: any) {
  return updateResponse(
    http(URL + `/systemOrderPackage/detachablePackage`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
